export default __webpack_public_path__ + "static/media/no_image.ac33be36.svg";